import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import MathModal from "./CommonC/MathModal";
import Projectcolors from "../Utils/Colors";
import SelexMathNavbar from "./CommonC/SelexMathNavbar";
import { makeStyles, withStyles } from "@mui/styles";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { baseURL } from "../Config/config";
import { useNavigate } from "react-router-dom";
import ShareProjectModal from "./CommonC/ShareProjectModal";
import { TextField } from "@mui/material"


import GlobalLoader from "./CommonC/GlobalLoader";
import BgContainer2 from "./CommonC/BgContainer2";
import { useSelector, useDispatch } from "react-redux";
import ShareIcon from "@mui/icons-material/Share";
import EditModal from "./CommonC/EditModal";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    height: 1,
  },
  tableCell: {
    padding: "0px 16px",
  },
  root: {
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    minHeight: "1px",
    padding: "0",
  },
});

const tableHeaders = [
  "Project Name",
  "Last Modified",
  "Edit",
  "Copy",
  "Delete",
  "Share"
];

function SelexSIM() {
  const [isModal, setIsModal] = React.useState(false);
  const [shareModal, setShareModal] = React.useState(false);
  const [shareProjectName, setShareProjectName] = React.useState("");
  const [shareProjectID, setShareProjecID] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [edit, setEdit] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [timer, setTimer] = React.useState(null);
  const [message, setmessage] = React.useState("");
  const [editProjectName, setEditProjectName] = React.useState("");
    const [editProjectID, setEditProjectID] = React.useState("");
    const [editClientName, setEditClientName] = React.useState("");
    const [editObjective, setEditObjective] = React.useState("");
     const [isLoading, setIsLoading] = React.useState(false);
     const [iseditModal, setIseditModal] = React.useState(false);
     const [searchProject, setSearchProject] = useState("");
       const navigate = useNavigate();




  const [projectDetails, setProjectDetails] = React.useState();
  const [getLoader, setGetLoader] = React.useState(false);

  const dispatch = useDispatch();
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
    setTimer(
      setTimeout(() => {
          setOpen(false);
      }, 2500)
  );

  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleeditClose = () => {
    setIseditModal(false);
  };
  const handleeditOpen = () => {
    setIseditModal(true);
  };


const filteredProjects =
  projectDetails?.filter((item) =>
    item.projectName
      ?.toLowerCase()
      .includes(searchProject.toLowerCase())
  ) || [];


  React.useEffect(() => {
    getAllProjects();
  }, []);


  const getProjectDetails = async () => {
    // setGetLoader(true);
    const token = sessionStorage.getItem("usertoken");
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json", token: token },
    };
 
    try {
      const result = await fetch(`${baseURL}/projectaccessdetails`, options);
      let res = await result.json();
      if (!res.code) {
        // setGetLoader(false);
        return;
      }
      // setGetLoader(false);
      // dispatch(create(res.projectDetails));
    } catch (error) {
      // setGetLoader(false);
      console.log("error", error);
    }
  };

  const getAllProjects = async (id) => {
    setGetLoader(true);
    const token = sessionStorage.getItem("usertoken");
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json", token: token },
    };

    try {
      const result = await fetch(`${baseURL}/allmathprojects`, options);
      let res = await result.json();
      if (!res.code) {
        setGetLoader(false);
        return;
      }
      // getProjectDetails();
      setGetLoader(false);
      setProjectDetails([...res.data]);
    } catch (error) {
      setGetLoader(false);
      console.log("error", error);
    }
  };

  const StyledTableRow = withStyles((theme) => ({
    root: {
      height: 5,
    },
  }))(TableRow);

  const StyledTableCell = withStyles((theme) => ({
    root: {
      padding: "0px 16px",
    },
  }))(TableCell);

  const deleteProject = async (id) => {
    let body = {
      projectID: id,
    };

    const token = sessionStorage.getItem("usertoken");

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json", Token: token },
      body: JSON.stringify(body),
    };
    try {
      let result = await fetch(`${baseURL}/deletemathproject`, options);
      result = await result.json();
      getAllProjects();
    } catch (error) {
      console.log("error", error);
    }
  };

  const copymathProject = async (id) => {
      let body = {
        projectID: id,
      };
  
      const token = sessionStorage.getItem("usertoken");
  
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json", Token: token },
        body: JSON.stringify(body),
      };
      try {
        let result = await fetch(`${baseURL}/copymathproject`, options);
        result = await result.json();
        getAllProjects();
      } catch (error) {
        console.log("error", error);
      }
    };

  const toggleModal = () => {
    return setIsModal(!isModal);
  };
  const toggleShareModal = (projectName, projectID) => {
    setShareModal(!shareModal);
    setShareProjecID(projectID);
    setShareProjectName(projectName);
  };

  const handleShareProject = async (value) => {
    const token = sessionStorage.getItem("usertoken");
    setEdit(value)

    const body = {
      email,
      shareProjectName,
      shareProjectID,
      editAccess: value,
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json", token: token },
      body: JSON.stringify(body),
    };

    try {
      let res = await fetch(`${baseURL}/mathshareproject`, options);
      res = await res.json();
      if (res.code === 1) {
        toggleShareModal();
        handleClickOpen();
        setmessage("Project Shared Successfully")
        return;
      }
      else if(res.code === 0){
        toggleShareModal();
        handleClickOpen();
        setmessage(res.message);
      }
      else if (res.code === 2){
        toggleShareModal();
        handleClickOpen();
        setmessage(res.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };


  const toggleEditModal = (projectName, projectID) => {
      
      fetch(
        `${baseURL}/mathprojecteditdetails?projectID=${projectID}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.message === 1) {
            setEditProjectName(data.projectName);
            setEditClientName(data.clientname);
            setEditObjective(data.objective);
  
            setEditProjectID(projectID)
            handleeditOpen()
          } else {
            console.log("");
          }
        })
        .catch((err) => {
          setGetLoader(false);
          console.log(err);
        });
    };
  
    const handleEditProject = async () => {
      const token = sessionStorage.getItem("usertoken");
      sessionStorage.setItem("projectID",editProjectID);
      sessionStorage.setItem("projectName",editProjectName);
      sessionStorage.setItem("loaded",true);
  
  
      const body = {
        editProjectID,
      editProjectName,
      editClientName,
      editObjective,
      time: new Date(),
      // projectID,
      
    };
  
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json", token: token },
        body: JSON.stringify(body),
      };
  
      try {
        let res = await fetch(`${baseURL}/matheditproject`, options);
        res = await res.json();
        if (res.code === 1) {
          setIsLoading(false);
          navigate("/newmathproject", { state: { loaded: true, ProjectID: editProjectID,projectName: editProjectName ,editAccess:edit,} });
          return;
  
        }
        
      } catch (error) {
        console.log("error", error);
      }
    };

 
  
  const handleNavigation = (projectID,projectName) => {
    navigate("/newmathproject", {
      state: {
        ProjectID: projectID,
        projectName:projectName,
        editAccess:edit,
        loaded: true,
      },
    });
  };

  //  onClick={()=>navigate("/newproject",{ state : {ProjectID:item.projectID,loaded:true}})}

return (
  <Box
    sx={{
      minHeight: "100vh",
      background:
        "linear-gradient(135deg, #f4f9ff 0%, #eef5fb 45%, #ffffff 100%)",
      position: "relative",
      overflow: "hidden",
      pb: 5,
    }}
  >
    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

    {/* TOP SECTION */}
    <Box
      sx={{
        width: "92%",
        maxWidth: "1250px",
        margin: "auto",
        mt: 4,
        position: "relative",
        zIndex: 2,
      }}
    >
      {/* HEADER ROW */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mb: 3,
        }}
      >
        {/* LEFT */}
        <Box>
          <Typography
            sx={{
              fontSize: { xs: 28, md: 34 },
              fontWeight: 700,
              color: "#0078c9",
              letterSpacing: "-1px",
            }}
          >
            Mathematical Modeling Projects
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              mt: 0.5,
            }}
          >
            Manage and organize all your simulation projects
          </Typography>
        </Box>

        {/* RIGHT */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {/* TOTAL PROJECTS */}
          <Box
            sx={{
              height: "48px",
              px: 3,
              borderRadius: "14px",
              background: "#fff",
              border: "1px solid #dbe7f3",
              display: "flex",
              alignItems: "center",
              boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                color: "#64748b",
                mr: 1,
              }}
            >
              Total Projects:
            </Typography>

            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0078c9",
              }}
            >
              {projectDetails?.length || 0}
            </Typography>
          </Box>

          {/* CREATE BUTTON */}
          <Button
            onClick={toggleModal}
            sx={{
              height: "48px",
              px: 4,
              borderRadius: "14px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              background:
                "linear-gradient(135deg, #0078c9 0%, #009dff 100%)",
              boxShadow: "0 10px 25px rgba(0,120,201,0.25)",
              color: "#fff",
              "&:hover": {
                background:
                  "linear-gradient(135deg, #006eb7 0%, #008de6 100%)",
              },
            }}
          >
            + Create Project
          </Button>
        </Box>
      </Box>

      {/* TABLE CARD */}
      <Box
        sx={{
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: "26px",
          border: "1px solid rgba(255,255,255,0.4)",
          boxShadow: "0 20px 50px rgba(15,23,42,0.08)",
          overflow: "hidden",
        }}
      >
        {/* TOP BAR */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            px: 3,
            py: 2.5,
            borderBottom: "1px solid #edf2f7",
            background:
              "linear-gradient(to right, rgba(0,120,201,0.04), rgba(255,255,255,0.5))",
          }}
        >
          {/* TITLE */}
          <Box>
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              Project Workspace
            </Typography>

            <Typography
              sx={{
                fontSize: 13,
                color: "#64748b",
                mt: 0.5,
              }}
            >
              View, edit, copy and manage your projects
            </Typography>
          </Box>

          {/* SEARCH */}
          <Box>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                color: "#475569",
                mb: 1,
                ml: 0.5,
              }}
            >
              Search Projects
            </Typography>

            <TextField
              placeholder="Search by project name..."
              value={searchProject}
              onChange={(e) =>
                setSearchProject(e.target.value)
              }
              size="small"
              InputProps={{
                startAdornment: (
                  <SearchIcon
                    sx={{
                      color: "#94a3b8",
                      mr: 1,
                      fontSize: 20,
                    }}
                  />
                ),
              }}
              sx={{
                width: "320px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "14px",
                  background: "#fff",
                  height: "45px",
                  fontSize: 14,
                },
                "& .MuiOutlinedInput-root fieldset": {
                  borderColor: "#dbe7f3",
                },
                "& .MuiOutlinedInput-root:hover fieldset": {
                  borderColor: "#0078c9",
                },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#0078c9",
                  borderWidth: "2px",
                },
              }}
            />
          </Box>
        </Box>

        {/* TABLE */}
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            background: "transparent",
            maxHeight: "68vh",
          }}
        >
          <Table
            stickyHeader
            sx={{
              minWidth: 850,
              "& .MuiTableCell-root": {
                borderBottom: "1px solid #edf2f7",
              },
            }}
          >
            {/* TABLE HEADER */}
            <TableHead>
              <TableRow>
                {tableHeaders.map((item) => (
                  <TableCell
                    key={item}
                    sx={{
                      backgroundColor: "#0078c9",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 13,
                      letterSpacing: "0.5px",
                      py: 2,
                    }}
                  >
                    {item.toUpperCase()}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            {/* TABLE BODY */}
            <TableBody>
              {filteredProjects.length > 0 ? (
                filteredProjects.map((item) => {
                  const dateStr = new Date(item.time)
                    .toDateString()
                    .substr(4);

                  return (
                    <TableRow
                      key={item.projectID}
                      hover
                      sx={{
                        transition: "0.25s",
                        "&:hover": {
                          backgroundColor: "#f8fbff",
                        },
                      }}
                    >
                      {/* PROJECT NAME */}
                      <TableCell>
                        <Typography
                          onClick={() =>
                            handleNavigation(
                              item.projectID,
                              item.projectName
                            )
                          }
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#0f172a",
                            cursor: "pointer",
                            transition: "0.2s",
                            "&:hover": {
                              color: "#0078c9",
                            },
                          }}
                        >
                          {item.projectName}
                        </Typography>
                      </TableCell>

                      {/* DATE */}
                      <TableCell>
                        <Typography
                          sx={{
                            fontSize: 13,
                            color: "#64748b",
                          }}
                        >
                          {dateStr}
                        </Typography>
                      </TableCell>

                      {/* EDIT */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            toggleEditModal(
                              item.projectName,
                              item.projectID
                            )
                          }
                          sx={{
                            background: "#e0f2fe",
                            "&:hover": {
                              background: "#bae6fd",
                            },
                          }}
                        >
                          <EditIcon
                            sx={{
                              color: "#0284c7",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {/* COPY */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            copymathProject(item.projectID)
                          }
                          sx={{
                            background: "#ecfeff",
                            "&:hover": {
                              background: "#cffafe",
                            },
                          }}
                        >
                          <ContentCopyIcon
                            sx={{
                              color: "#0891b2",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {/* DELETE */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            deleteProject(item.projectID)
                          }
                          sx={{
                            background: "#fef2f2",
                            "&:hover": {
                              background: "#fee2e2",
                            },
                          }}
                        >
                          <DeleteIcon
                            sx={{
                              color: "#dc2626",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {/* SHARE */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            toggleShareModal(
                              item.projectName,
                              item.projectID
                            )
                          }
                          sx={{
                            background: "#eff6ff",
                            "&:hover": {
                              background: "#dbeafe",
                            },
                          }}
                        >
                          <ShareIcon
                            sx={{
                              color: "#2563eb",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Box
                      sx={{
                        py: 8,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#64748b",
                        }}
                      >
                        No Projects Found
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 13,
                          color: "#94a3b8",
                          mt: 1,
                        }}
                      >
                        Try searching with another project name
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>

    {/* MODALS */}
    <MathModal
      isModal={isModal}
      toggleModal={toggleModal}
    />

    <EditModal
      isModal={iseditModal}
      setIseditModal={setIseditModal}
      handleeditClose={handleeditClose}
      toggleModal={toggleEditModal}
      handleEditProject={handleEditProject}
      editProjectName={editProjectName}
      editClientName={editClientName}
      editObjective={editObjective}
      setEditClientName={setEditClientName}
      setEditProjectName={setEditProjectName}
      setEditObjective={setEditObjective}
      setEditProjectID={setEditProjectID}
      editProjectID={editProjectID}
    />

    <ShareProjectModal
      isModal={shareModal}
      handleShareProject={handleShareProject}
      setEmail={setEmail}
      email={email}
      toggleModal={toggleShareModal}
    />

    {getLoader && <GlobalLoader />}
  </Box>
);
}

export default SelexSIM;
